import MeusAtendimentos from "./MeusAtendimentosAssistencia";
import TodosAtendimentos from "./TodosAtendimentosAssintencia";
import GrupoAtendimentos from "./GrupoAtendimentosAssistencia";

export const GestaoAssitenciaTecnica = {
    TodosAtendimentos,
    MeusAtendimentos,
    GrupoAtendimentos,
};
